$(function () {
	$(".slide").slick({
		fade: true,
		speed: 1500,
		autoplaySpeed: 3000,
		arrows: false,
		autoplay: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: true,
	});
});

$(function () {
	$(".menu_btn").click(function () {
		if ($(this).hasClass("active")) {
			$(this).removeClass("active");
			$(".nav").removeClass("active");
		} else {
			$(this).addClass("active");
			$(".nav").addClass("active");
		}
	});
});

$(function () {
	var scroll;
	scroll = $(window).scrollTop();
	if (scroll > 1) {
		//ここに処理
		$("header.top").css("background", "#000");
		$("header.top .inner").css({ height: "100%", "align-items": "center" });
		$("header.top .header_list").addClass("mt0");
		$("header.top .logo_box").css("opacity", "0");
		$("header.top .logo_box").css("display", "none");
		$("header.top .logo_box_sec").css("opacity", "1.0");
		$("header.top .logo_box_sec").css("display", "block");
	} else {
		$("header.top").css("background", "unset");
		$("header.top .inner").css({
			height: "unset",
			"align-items": "self-start",
		});
		$("header.top .header_list").removeClass("mt0");
		$("header.top .logo_box").css("opacity", "1");
		$("header.top .logo_box").css("display", "block");
		$("header.top .logo_box_sec").css("opacity", "0");
		$("header.top .logo_box_sec").css("display", "none");
	}
	$(window).on("scroll", function () {
		scroll = $(window).scrollTop();
		if (scroll > 1) {
			//ここに処理
			$("header.top").css("background", "#000");
			$("header.top .inner").css({ height: "100%", "align-items": "center" });
			$("header.top .header_list").addClass("mt0");
			$("header.top .logo_box").css("opacity", "0");
			$("header.top .logo_box").css("display", "none");
			$("header.top .logo_box_sec").css("opacity", "1.0");
			$("header.top .logo_box_sec").css("display", "block");
		} else {
			$("header.top").css("background", "unset");
			$("header.top .inner").css({
				height: "unset",
				"align-items": "self-start",
			});
			$("header.top .header_list").removeClass("mt0");
			$("header.top .logo_box").css("opacity", "1");
			$("header.top .logo_box").css("display", "block");
			$("header.top .logo_box_sec").css("opacity", "0");
			$("header.top .logo_box_sec").css("display", "none");
		}
	});
});

$(function () {
	const swiper = new Swiper(".mySwiper", {
		spaceBetween: 10,
		slidesPerView: 5,
		allowSlideNext: false,
		allowSlidePrev: false,
	});

	const swiper2 = new Swiper(".mySwiper2", {
		thumbs: {
			swiper: swiper,
		},
	});
});

$(function () {
	$(".modal .yes").click(function () {
		$(".modal").css("display", "none");
      return false;
	});
	$(".modal .no").click(function () {
		window.open("about:blank", "_self").close();
		return false;
	});
});

$(function () {
	$(".modal_02 .close").click(function () {
		$(".modal_02").css("display", "none");
      return false;
	});
});

// $(function () {
// 	$(".mv_box .teiki").click(function () {
// 		$(".modal_02").css("display", "block");
//       return false;
// 	});
// });

$(function () {
	var webStorage = function () {
		if (sessionStorage.getItem("access")) {
			/*
		  2回目以降アクセス時の処理
		*/
		} else {
			/*
		  初回アクセス時の処理
		*/
			sessionStorage.setItem("access", "true"); // sessionStorageにデータを保存
			$(".modal").addClass("is-active");
		}
	};
	webStorage();
});

$(function () {
	$(".js-accordion_title").click(function () {
		$(this).next(".js-accordion_inner").slideToggle(), $(this).toggleClass("open");
		$(this).find(".icon").toggleClass("active");
	});
});

// Sample 1
$(function () {
	$(".js-hover").each(function () {
		var src_off = $(this).find("img").attr("src"),
			src_on = src_off.replace("_off", "_on");

		$(".js-hover").attr("src", src_off);

		$(this).hover(
			function () {
				$(this).find("img").attr("src", src_on);
			},
			function () {
				$(this).find("img").attr("src", src_off);
			},
		);
	});
});

$(function () {
	const windowHeight = $(window).height();
	const scroll = $(window).scrollTop();

	$(".fade").each(function () {
		const targetPosition = $(this).offset().top;
		if (scroll > targetPosition - windowHeight + 100) {
			$(this).addClass("is-fadein");
		} else {
			$(this).removeClass("is-fadein");
		}
	});

	$(window).scroll(function () {
		const windowHeight = $(window).height();
		const scroll = $(window).scrollTop();

		$(".fade").each(function () {
			const targetPosition = $(this).offset().top;
			if (scroll > targetPosition - windowHeight + 100) {
				$(this).addClass("is-fadein");
			} else {
				$(this).removeClass("is-fadein");
			}
		});
	});
});
$(function(){
  $(".nav_box nav li").each(function(){
    $(this).removeClass("active");
  })
  if(document.URL.match(/collections/)) {
    $(".nav_box nav .link_list li:nth-child(2)").addClass("active");
  }else if(document.URL.match(/news/)){
    $(".nav_box nav .link_list li:nth-child(3)").addClass("active");
  }else if(document.URL.match(/tool/)){
    $(".nav_box nav .link_list li:nth-child(4)").addClass("active");
  }else if(document.URL.match(/guide/)){
    $(".nav_box nav .link_list li:nth-child(5)").addClass("active");
  }else if(document.URL.match(/faq/)){
    $(".nav_box nav .link_list li:nth-child(6)").addClass("active");
  }else{
    $(".nav_box nav .link_list li:nth-child(1)").addClass("active");
    $(".nav_box nav .link_list li ul li:nth-child(1)").removeClass("active");

  }
})

$(function(){

    if(document.URL.match(/en/)) {

      $(".header_list .lang li a").removeClass("active");
      $(".header_list .lang li #lang_url_en").addClass("active");
    }else{
      $(".header_list .lang li a").removeClass("active");
      $(".header_list .lang li #lang_url_ja").addClass("active");
    }

})